import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import Modal from '../../../../components/modal/Modal';
import Button from '../../../../../components/form/button/Button';
import { Color } from '../../../../../core/enums/Color';
import { RootState } from '../../../../../core/state/state';
import { GlobalNotificationTypes } from '../../../../../core/enums/GlobalNotificationTypes';
import { spawnGlobalNotification } from '../../../../../core/state/global-notifications/asyncActions';
import { sendBookingEmail } from '../../../../../core/state/bookings/asyncActions';
import { isMobileScreenSize } from '../../../../../core/utils/isMobileScreenSize';

interface Props {
  isOpen: boolean;
  closeModal: () => void;
  bookingId: string;
}

const SendEmailAfterBookingModal: React.FC<Props> = ({ isOpen, closeModal, bookingId }) => {
  const { isOpen: isAnyModalOpen } = useSelector((state: RootState) => state.bookings.modal);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isMobileScreen = isMobileScreenSize();

  const onConfirm = async () => {
    dispatch(sendBookingEmail(Number(bookingId)));
    closeModal();
    dispatch(
      spawnGlobalNotification({
        type: GlobalNotificationTypes.Success,
        title: t('booking.send.email.success.title'),
        message: t('booking.send.email.success.text'),
        delay: 5000
      })
    );
  };

  const closeEmailModal = () => {
    closeModal();
    dispatch(
      spawnGlobalNotification({
        type: GlobalNotificationTypes.Info,
        title: t('common.changesDiscarded'),
        message: t('booking.send.email.reject.text'),
        delay: 5000
      })
    );
  };

  const title = <h3 className="modal-title">{t('booking.send.email.title')}</h3>;
  const buttons = (
    <div className="modal-buttons">
      <Button onClick={closeEmailModal} buttonTypes={!isMobileScreen ? ['transparent'] : ['outline', 'block']} color={Color.Blue}>
        {t('common.no')}
      </Button>
      <Button onClick={onConfirm} buttonTypes={!isMobileScreen ? ['primary'] : ['primary', 'block']} color={Color.Blue}>
        {t('common.yes')}
      </Button>
    </div>
  );

  return (
    <Modal
      className={isMobileScreen ? 'modal--small-mobile' : ''}
      isOpen={!isAnyModalOpen && isOpen}
      closeModal={closeEmailModal}
      title={title}
      toolbar={buttons}
      size="small"
    >
      <span>{t('booking.send.email.text')}</span>
    </Modal>
  );
};

export default SendEmailAfterBookingModal;
